var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRankSilverRibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.256 9.149A10.12 10.12 0 006.128 19.277c0 1.25.238 2.442.655 3.514L19.77 9.804a9.704 9.704 0 00-3.514-.655z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.77 9.804L6.783 22.791c1.43 3.873 5.124 6.613 9.473 6.613a10.12 10.12 0 0010.127-10.128c0-4.348-2.74-8.042-6.613-9.472z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.081 9.685l4.35-2.204c.237-.06.357-.238.357-.477V2H19.83v7.149c-1.132-.417-2.323-.596-3.574-.596s-2.443.238-3.575.596V2H6.724v5.004c0 .239.119.417.357.536l4.35 2.205a10.598 10.598 0 00-5.899 9.532C5.532 25.174 10.358 30 16.256 30c5.898 0 10.723-4.826 10.723-10.723 0-4.17-2.383-7.805-5.898-9.592zm-4.825 18.528a8.924 8.924 0 01-8.937-8.936 8.924 8.924 0 018.937-8.937 8.924 8.924 0 018.936 8.937 8.924 8.924 0 01-8.936 8.936z",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.03 18.264c-1.311-.417-1.311-.417-1.55-.596-.476-.238-.655-.536-.655-.953 0-.715.656-1.31 1.49-1.31.774 0 1.49.357 2.025 1.012l1.37-1.609c-.953-.953-2.085-1.43-3.395-1.43-2.145 0-3.754 1.43-3.754 3.277 0 1.668.954 2.621 3.396 3.396.894.298 1.013.358 1.37.536.477.298.715.596.715 1.192 0 .834-.655 1.37-1.727 1.37-.954 0-1.907-.536-2.562-1.37l-1.37 1.489c1.013 1.251 2.383 1.906 3.932 1.906 2.383 0 4.05-1.37 4.05-3.336-.118-1.727-1.071-2.8-3.335-3.574z",
    fill: "#646464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.256 8.553c1.251 0 2.443.238 3.575.596V2h-7.15v7.149c1.133-.358 2.324-.596 3.575-.596z",
    fill: "#838383"
  })));
}

export default SvgIconRankSilverRibbon;